import { useScreenSize } from "@/hooks";

type GlobalIconProps = {
    color?: string;
    width?: number;
    height?: number;
    className?: string;
};

const GlobalIcon = ({ color = 'currentColor', width = 16, height = 16, className }: GlobalIconProps) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 16 16" fill="none" className={className}>
            <g clipPath="url(#clip0_8248_44200)">
                <circle cx="8" cy="8" r="7.4" stroke={color} strokeWidth="1.2" />
                <path
                    d="M8.00006 0.599609C8.65935 0.599649 9.44225 1.19644 10.0958 2.59668C10.7266 3.94846 11.1329 5.85832 11.1329 8C11.1329 10.1417 10.7266 12.0515 10.0958 13.4033C9.44225 14.8036 8.65935 15.4004 8.00006 15.4004C7.34071 15.4004 6.55695 14.8038 5.90338 13.4033C5.27255 12.0515 4.86627 10.1417 4.86627 8C4.86627 5.85833 5.27255 3.94846 5.90338 2.59668C6.55695 1.19617 7.34071 0.599609 8.00006 0.599609Z"
                    stroke={color}
                    strokeWidth="1.2"
                />
                <path fillRule="evenodd" clipRule="evenodd" d="M14.9333 6.2H1.06665V5H14.9333V6.2Z" fill={color} stroke={color} strokeWidth="1.5" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.9333 11.0008H1.06665V9.80078H14.9333V11.0008Z"
                    fill={color}
                    stroke={color}
                    strokeWidth="1.5"
                />
            </g>
            <defs>
                <clipPath id="clip0_8248_44200">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default GlobalIcon;
